/**
 * Show Hesus transport options.
 * transport-list?state=1&type=0
 */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import i18next from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import { Anchor } from "hesus-ui-kit";
import getTransportQuotations from "./TransportQuotations.actionCreators";
import { getTransportQuotationsLoadState } from "./TransportQuotations.slice";
import EncloseTable from "@shared/baseUI/EnhancedTable/EncloseTable";

import { isEmpty } from "@utils/utils";
import UserInfo from "@utils/UserInfo";
import Action from "./Action";

import {
  PAGE_SIZE,
  TABLE_TRANSPORT_QUOTATIONS,
  FILTER_TYPE_MULTI_SELECT_DROPDOWN,
} from "@utils/constants";

import "./TransportQuotations.scss";

const TransportQuotations = (props) => {
  const { t } = props;
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [isRefreshDataAgain, setRefreshState] = useState(false);
  const [skipPageReset, setSkipPageReset] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [requestData, setRequestData] = useState({});
  const [currentPageToFirst, setCurrentPageToFirst] = useState(false);
  const [additionalFilters, setAdditionalFilters] = useState([]);

  const mainCountryInfo = UserInfo.countryInfo();

  const [countryId, setCountryId] = useState(UserInfo.countryId());
  const [countryList, setCountryList] = useState(
    UserInfo.countryListForFilter(t)
  );

  const [selectedFilter, setSelectedFilter] = useState([
    {
      column: "country",
      value: {
        value: mainCountryInfo?.country?.id,
        label: t(mainCountryInfo?.country?.name),
      },
    },
  ]);
  const dataURL = "/solutions/transportQuotation";

  const refreshData = (data) => {
    setRefreshState(data);
  };

  const columns = [
    {
      Header: t("ID"),
      accessor: "id",
      disableFilters: true,
    },
    {
      Header: t("SITE"),
      Cell: ({ cell: { value } }) => (
        <Anchor url={`/site/view/${value.id}/general-info`} target="_blank">
          {value.name}
        </Anchor>
      ),
      accessor: "siteName",
      disableFilters: true,
    },
    {
      Header: t("CLIENT"),
      accessor: "clientName",
      Cell: ({ cell: { value } }) => (
        <Anchor url={`/company/view/${value.id}/general-info`} target="_blank">
          {value.name}
        </Anchor>
      ),
      disableFilters: true,
    },
    {
      Header: t("CENTER"),
      accessor: "centreName",
      Cell: ({ cell: { value } }) => (
        <Anchor url={`/company/view/${value.id}/general-info`} target="_blank">
          {value.name}
        </Anchor>
      ),
      disableFilters: true,
    },
    {
      Header: t("SUPPLIER"),
      accessor: "supplierName",
      Cell: ({ cell: { value } }) => (
        <Anchor url={`/company/view/${value.id}/general-info`} target="_blank">
          {value.name}
        </Anchor>
      ),
      disableFilters: true,
    },
    {
      Header: t("Service"),
      accessor: "service",
      disableFilters: true,
    },
    {
      Header: t("CREATION_DATE"),
      accessor: "creationDate",
      disableFilters: true,
    },
    {
      Header: t("ACTION"),
      accessor: "action",
      Cell: ({ cell: { value } }) => (
        <Action data={value} onRefreshData={refreshData} />
      ),
      disableFilters: true,
      disableSortBy: true,
    },
  ];

  const transportQuotationsByIds = useSelector(
    (state) => state.transportQuotations.byId
  );
  const transportQuotationsAllIds = useSelector(
    (state) => state.transportQuotations.allIds
  );
  const filteredRecords = useSelector(
    (state) => state.transportQuotations.filteredRecords
  );

  /**
   * Method to fetch set of records based on the filters applied.
   * @param {pageSize} pageSize
   * @param {pageStart} pageStart
   * @param {globalFilter} globalFilter
   * @param {sort} sort
   * @param {appliedFilters} appliedFilters
   */
  const fetchRecords = ({
    pageSize,
    pageStart,
    globalFilter,
    sort,
    appliedFilters,
    currentPage,
  }) => {
    // save request data,
    setRequestData({
      pageSize,
      pageStart,
      globalFilter,
      sort,
      appliedFilters,
      currentPage,
    });

    let selectedCountries = [];
    if (additionalFilters.length > 0) {
      const countryTypeFilter = additionalFilters.filter(
        (filterItem) => filterItem.column === "country"
      );
      selectedCountries = countryTypeFilter?.map((item) => item.value);
    }
    if (selectedCountries.length === 0) {
      selectedCountries = countryId;
    }
    // Set the loading state
    setLoading(true);

    dispatch(getTransportQuotationsLoadState());
    dispatch(
      getTransportQuotations({
        dataURL,
        pageSize,
        currentPage,
        sort,
        search: globalFilter,
        selectedCountries,
      })
    );
  };

  useEffect(() => {
    if (transportQuotationsAllIds.length > 0) {
      const responseData = transportQuotationsAllIds.map((id) => {
        const tempData = { ...transportQuotationsByIds[id] };
        tempData.siteName = {
          name: tempData.site?.name ?? "",
          id: tempData.site?.id,
        };
        tempData.clientName = {
          name: tempData.site?.companyName ?? "",
          id: tempData.site?.companyId,
        };
        tempData.centreName = {
          name: tempData.centre?.companyName ?? "",
          id: tempData.centre?.companyId,
        };
        tempData.supplierName = {
          name: tempData.centre?.supplierName ?? "",
          id: tempData.centre?.supplierId,
        };
        tempData.service = tempData.enquiry?.service
          ? t(tempData.enquiry?.service)
          : "";
        tempData.distance = tempData.distance ?? "";
        tempData.creationDate = tempData.createdAt;
        tempData.action = {
          id: tempData.id,
          name: t("ADD_A_TP_PRICE"),
          countryId: tempData.site?.platformCountry?.id,
        };
        return tempData;
      });
      setData([...responseData]);
      setPageCount(filteredRecords);
      setLoading(false);
    } else {
      setData([]);
      setPageCount(0);
      setLoading(false);
    }
  }, [t, transportQuotationsAllIds, transportQuotationsByIds, filteredRecords]);

  useEffect(() => {
    if (isRefreshDataAgain) {
      setRefreshState(false);
    }
  }, [isRefreshDataAgain]);

  useEffect(() => {
    // everyTime we apply an custom filter we reset the page to 1
    setCurrentPageToFirst(true);
    if (!isEmpty(requestData) && requestData.currentPage === 1) {
      fetchRecords({
        pageSize: requestData.pageSize,
        pageStart: requestData.pageStart,
        globalFilter: requestData.globalFilter,
        sort: requestData.sort,
        currentPage: requestData.currentPage,
        appliedFilters: additionalFilters,
      });
    }
  }, [additionalFilters]);

  return (
    <section className="request-completed-list__container">
      <h2 className="request-completed-list__title">
        {t("TRANSPORT_QUOTATION")}
      </h2>
      <EncloseTable
        type={TABLE_TRANSPORT_QUOTATIONS}
        columns={columns}
        data={data}
        setData={setData}
        initialPageSize={PAGE_SIZE}
        isRefreshDataAgain={isRefreshDataAgain}
        setSkipPageReset={setSkipPageReset}
        skipPageReset={skipPageReset}
        pageCount={pageCount}
        setPageCount={setPageCount}
        fetchRecords={fetchRecords}
        currentPageToFirst={currentPageToFirst}
        setCurrentPageToFirst={setCurrentPageToFirst}
        loading={loading}
        setAdditionalFilters={setAdditionalFilters}
        additionalFilters={additionalFilters}
        defaultSortOptions={[{ id: "id", desc: true, dir: "desc" }]}
        selectedFilter={selectedFilter}
        extraFilters={[
          ...(countryList?.length > 1
            ? [
                {
                  type: FILTER_TYPE_MULTI_SELECT_DROPDOWN,
                  label: t("COUNTRY"),
                  name: "country",
                  labelClass: "request-completed-list__admins-list-label",
                  containerClass:
                    "request-completed-list__admins-list-dropdown-container",
                  options: countryList,
                  placeholder: t("SEARCH"),
                  defaultOption: "Nothing Selected",
                },
              ]
            : []),
        ]}
      />
    </section>
  );
};

TransportQuotations.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(TransportQuotations);
